import React, { Component } from 'react';
import RFIDInstance, { WRITE_CPU1_PAGE, WRITE_CPU2_PAGE } from '../../../native-interact/RFID';
import Button from '../../../components/button/Button';
import { parseHexToStr } from '../../../js/utils';

export default class ReadPart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBtn: true,
      parts: []
    };
  }

  startRead() {
    this.setState({
      showBtn: false
    });

    const allPages = [...WRITE_CPU1_PAGE, ...WRITE_CPU2_PAGE];
    const tasks = allPages.map((item) => {
      return function () {
        let count = 0;
        return new Promise((resolve, reject) => {
          (function executeCommand() {
            count++;
            if (count >= 300) {
              return reject(new Error('执行超时'));
            }

            return RFIDInstance.read({
              step: 'read page',
              desc: '读取分区'
            }, [item, item + 2])
              .then((value) => {
                resolve(value);
              })
              .catch(() => {
                executeCommand();
              });
          }());
        });
      };
    });

    tasks.reduce(
      (previousPromise, nextPromise, index) => {
        return previousPromise
          .then((data) => {
            if (index > 0) {
              const result = data && data.substr(0, 8) !== '00000000' ? parseHexToStr(data) : '';
              this.setState((prevState) => {
                return {
                  parts: prevState.parts.concat(
                    [<p>{allPages[index - 1]}: {result}({data})</p>]
                  )
                };
              });
            }
            return nextPromise();
          })
          .catch(() => {
            this.setState((prevState) => {
              return {
                parts: prevState.parts.concat(
                  [<p>{allPages[index]}: 读取失败</p>]
                )
              };
            });
            return Promise.resolve();
          });
      },
      Promise.resolve()
    ).then((data) => {
      const result = data && data.substr(0, 8) !== '00000000' ? parseHexToStr(data) : '';
      this.setState((prevState) => {
        return {
          parts: prevState.parts.concat(
            [<p>{allPages[allPages.length - 1]}: {result}({data})</p>]
          )
        };
      });
    });
  }

  render() {
    return (
      <div>
        <h4 className="popup-title">读取分区</h4>
        {this.state.parts}
        <div style={{ textAlign: 'center' }}>
          <Button
            style={{ display: this.state.showBtn ? 'inline-block' : 'none' }}
            onClick={() => this.startRead()}
          >
            点击开始读取
          </Button>
        </div>
      </div>
    );
  }
}
